<template>
  <div class="content-box">
    <div class="row">
      <div class="col-md-12" v-if="!usuarioPermitido">
        <NoPermitidoComponent></NoPermitidoComponent>
      </div>
      <div class="col-md-12" v-else>
        <div
          style="height: 30rem;"
          :class="{
            'element-wrapper loader-wrapper': !cargado,
            'element-wrapper': cargado,
          }"
        >
          <LoaderComponent
            :condicion="cargado"
          ></LoaderComponent>
          <div v-if="cargado" class="element-box row">
            <div class="col-md-5 col-sm-12">
              <center>
                <select
                  style="width: 85%;"
                  v-model="currentDetalles.tienda.codigo"
                  class="form-control form-control-sm rounded bright"
                  @change="refreshCurrent"
                >
                  <option
                    v-for="tienda in currentDetalles.tiendas"
                    :value="tienda.codigo"
                    v-bind:key="tienda.id"
                  >{{tienda.nombre}}</option>
                </select>
              </center>
              <!-- Componente del calendario -->
              <div class="calendar">
                <div class="calendar-header">
                  <button @click="changeMonth(-1)">&lt;</button>
                  <h3 style="cursor: pointer;" @click="selectDate()">{{ currentMonthName }} {{ currentYear }}</h3>
                  <button @click="changeMonth(1)">&gt;</button>
                </div>
                <div class="calendar-grid">
                  <div class="day-name" v-for="day in dayNames" :key="day">{{ day }}</div>
                  <div
                    v-if="estadosCargados"
                    class="day"
                    v-for="(day, index) in daysInMonth"
                    :key="index"
                    :style="getEstadoCortesTienda(day)"
                    :class="{ 
                      'disabled': isDisabled(day),
                      'aperturado': estadoCortes(day) === 'A' && !isSelectedDay(day),
                      'pendiente': estadoCortes(day) === 'B' && !isSelectedDay(day),
                      'cerrado': estadoCortes(day) === 'C' && !isSelectedDay(day),
                      'aperturado-select': estadoCortes(day) === 'A' && isSelectedDay(day),
                      'pendiente-select': estadoCortes(day) === 'B' && isSelectedDay(day),
                      'cerrado-select': estadoCortes(day) === 'C' && isSelectedDay(day),
                      'is-today': isSelectedDay(day), 
                      'day': estadoCortes(day) == null,
                    }"
                    
                    @click="!isDisabled(day) && selectDay(day)"
                  >
                    {{ day }}
                  </div>
                </div>
              </div>
              <small
                style="color: gray" class="font-weight-bold"
              >
              <a style="color: #3273c1;cursor: pointer;" data-target="#estadosCortes" data-toggle="modal">ver estados diarios</a>
              </small>
            </div>
            <div class="col-md-7 col-sm-12 row mt-3">
              <div class="col-md-12">
                <div class="st-meta float-right">
                  &nbsp;
                  <div class="btn-group">
                    <div class="dropleft">
                      <button v-if="!hayCorteTienda || current.estado >= 'A'" class="btn btn-sm btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-cogs"></i> Acciones
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <h6 class="dropdown-header">Opciones</h6>
                        <button type="button" v-if="!hayCorteTienda" data-toggle="modal" @click="selectAction('apertura')" data-target="#loginVerifyModal" class="dropdown-item">
                          <i class="fas fa-box-open mr-2"></i>Aperturar
                        </button>
                        <button type="button" v-if="hayCorteTienda && current.estado === 'A'" @click="cerrar()" class="dropdown-item">
                          <i class="fas fa-box mr-2"></i>Cerrar
                        </button>
                        <button 
                          type="button" 
                          v-if="hayCorteTienda && current.estado === 'B' && listoParaFinalizar" 
                          data-toggle="modal" data-target="#loginVerifyModal" 
                          @click="selectAction('finalizar')"
                          class="dropdown-item"
                        >
                          <i class="fas fa-check mr-2"></i>Finalizar
                        </button>
                        <button
                          type="button" 
                          v-if="hayCorteTienda && current.estado === 'C'" 
                          data-toggle="modal" data-target="#loginVerifyModal" 
                          @click="selectAction('auditar')" class="dropdown-item"
                        >
                          <i class="fas fa-list mr-2"></i>Auditar
                        </button>
                        <button v-if="hayCorteTienda && current.estado <= 'B'" type="button" data-toggle="modal" data-target="#modalOperacion" class="dropdown-item">
                          <i class="fas fa-file mr-2"></i>Nueva operación
                        </button>
                        <button v-if="hayCorteTienda" type="button" data-toggle="modal" @click="verAnotaciones"  class="dropdown-item">
                          <i class="fas fa-list mr-2"></i>Ver anotaciones
                        </button>
                        <button v-if="hayCorteTienda" type="button"  @click.prevent="showAnotacionModal = true" class="dropdown-item">
                          <i class="fas fa-sticky-note mr-2"></i>Nueva anotación
                        </button>
                        <hr class="dropdown-divider">
                        <button type="button" v-if="hayCorteTienda && current.estado >= 'A'" class="dropdown-item" @click="verLogs()">
                          <i class="fas fa-history"></i>Ver Histórico
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="!hayCorteTienda">
                <div class="alert" style="background-color: #ee705c;" role="alert">
                  <h4 class="alert-heading" style="color: #3e3949;">Observaciones:</h4>
                  <p class="text-dark font-weight-bold"></p>
                  <h6 class="fas fa-info text-info" style="font-size: 12px;"></h6>
                  <span style="color: #5b5170; font-size: 15px;">&nbsp;<b>La tienda {{ currentDetalles.tienda.nombre }}({{ currentDetalles.tienda.codigo }}) no tiene apertura el día {{ selectedDate }}!</b></span>
                  <br>&nbsp;
                  <span class="text-dark" style="font-size: 14px; color: #3e3949;">
                    Debe aperturar tienda para poder iniciar labores del día
                  </span>
                  <p class="mb-0"></p>
                  <i class="fas fa-check-circle"
                    style="font-size: 100px; position: absolute; right: 1px; top: 55px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 0;"></i>
                </div>
              </div>
              <div class="col-md-12" v-else>
                <h5>
                  Corte de tienda #{{ current.numero }}
                  <span class="badge badge-blue mr-2" v-if="current.estado === 'B'">Cerrado</span>
                  <span class="badge badge-success mr-2" v-if="current.estado === 'A'">Abierto</span>
                  <span class="badge badge-dark mr-2" v-if="current.estado === 'C'">Finalizado</span>
                  <span class="badge badge-danger mr-2" v-if="current.estado === 'D'">Auditado</span>
                  <span class="badge badge-info" v-if="resultadoCuadre == 0 && currentDetalles.cortes.length>0">Cuadrado</span>
                  <span class="badge badge-danger" v-if="resultadoCuadre < 0">Faltante</span>
                  <span class="badge badge-success" v-if="resultadoCuadre > 0">Sobrante</span>
                  <span class="badge badge-parpadeo ml-2" v-if="listoParaFinalizar">Listo para finalizar</span>
                </h5>
                <small>ID: {{ current.id }}</small>
                <small style="color: gray" class="font-weight-bold" v-if="current.estado === 'D'">
                  Información del corte de tienda:
                  <br>
                  <div v-if="current.estado === 'D' || current.usuario_audita ">
                    <i style="color: gray" class="fas fa-info-circle"></i>
                    El corte de tienda ha sido auditado por el usuario {{ current.usuario_audita }} el día {{ current.fecha_auditado | moment("DD/MM/YYYY HH:MM") }}.
                  </div><br>
                </small>
                <table class="table" style="font-size: 12px;">
                  <thead>
                    <tr>
                      <th class="text-left">Fecha de apertura</th>
                      <th class="text-left">Fecha Cierre</th>
                      <th class="text-left">Listo para finalizar</th>
                      <th class="text-left">Fecha Finalizado</th>
                      <th class="text-left">Fecha Auditado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">{{ current.fecha_apertura | moment("DD/MM/YYYY HH:MM") }}</td>
                      <td class="text-left">{{ current.fecha_corte | moment("DD/MM/YYYY HH:MM") }}</td>
                      <td class="text-left" v-if="current.fecha_listo_finalizar">{{ current.fecha_listo_finalizar | moment("DD/MM/YYYY HH:MM") }}</td>
                      <td class="text-left" v-else></td>
                      <td class="text-left"></td>
                    </tr>
                  </tbody>
                </table>
                <table class="table" style="font-size: 12px;">
                  <thead>
                    <tr>
                      <th class="text-left">Total Detalles</th>
                      <th class="text-left">Total Sistema</th>
                      <th class="text-left">Total Caja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">Q {{ totalDetallesTotalizados }}</td>
                      <td class="text-left">Q {{ totalSistema }}</td>
                      <td class="text-left">Q {{ totalCajaTotalizados }}</td>
                    </tr>
                  </tbody>
                  <caption>
                  Estados:
                  <div
                    class="mr-1 status-pill green"
                    data-title="Aperturado"
                    data-toggle="tooltip"
                  ></div>Aperturado
                  <div
                    class="ml-2 mr-1 status-pill blue"
                    data-title="Corte"
                    data-toggle="tooltip"
                  ></div>Cerrado
                  <div
                    class="ml-2 mr-1 status-pill dark"
                    data-title="Finalizado"
                    data-toggle="tooltip"
                  ></div>Finalizado
                  <div
                    class="ml-2 mr-1 status-pill red"
                    data-title="Auditado"
                    data-toggle="tooltip"
                  ></div>Auditado
                </caption>
                </table>
              </div>
            </div>
            <div class="col-md-12 table-responsive mt-3">
              <center>
                <h5>Cortes del día</h5>
              </center>
              <table class="table table">
                <caption>
                  Estados:
                  <div
                    class="mr-1 status-pill green"
                    data-title="Aperturado"
                    data-toggle="tooltip"
                  ></div>Aperturado
                  <div
                    class="ml-2 mr-1 status-pill yellow"
                    data-title="Pendiente"
                    data-toggle="tooltip"
                  ></div>Pendiente
                  <div
                    class="ml-2 mr-1 status-pill blue"
                    data-title="Corte"
                    data-toggle="tooltip"
                  ></div>Cerrado
                  <div
                    class="ml-2 mr-1 status-pill dark"
                    data-title="Finalizado"
                    data-toggle="tooltip"
                  ></div>Finalizado
                  <div
                    class="ml-2 mr-1 status-pill red"
                    data-title="Auditado"
                    data-toggle="tooltip"
                  ></div>Auditado
                </caption>
                <thead>
                  <tr>
                    <th class="text-center">Caja</th>
                    <th class="text-center">#</th>
                    <th class="text-center">Cajero</th>
                    <th class="text-center">Hora Apertura</th>
                    <th class="text-center">Hora Cierre</th>
                    <th colspan="2" class="text-center">Total Caja</th>
                    <th colspan="2" class="text-center">Total Sistema</th>
                    <th class="text-center">Estado</th>
                    <th colspan="2" class="text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!hayCortes">
                    <td colspan="11" class="text-center">Aún no hay datos para mostrar...</td>
                  </tr>
                  <tr
                    v-for="corte in currentDetalles.cortes_disponibles"
                  >
                    <td class="text-center">{{corte.caja.caja}}</td>
                    <td class="text-center">{{corte.numero}}</td>
                    <td class="text-center">{{corte.usuario.nombre}}</td>
                    <td class="text-center">{{corte.fecha_apertura | moment("HH:MM")}}</td>
                    <td v-if="corte.fecha_cierre != null" class="text-center">{{corte.fecha_cierre | moment("HH:MM")}}</td>
                    <td v-else class="text-center"></td>
                    <td colspan="2" class="text-center">Q {{corte.total_detalles}}</td>
                    <td colspan="2" class="text-center">Q {{corte.total_corte}}</td>
                    <td class="text-center">
                      <div
                        :class="{
                          'status-pill green':corte.estado === 'A',
                          'status-pill yellow':corte.estado === 'B',
                          'status-pill blue':corte.estado === 'C',
                          'status-pill dark': corte.estado === 'F',
                          'status-pill red': corte.estado === 'Z',
                        }"
                        :data-title="corte.estado_corte"
                        data-toggle="tooltip"
                      ></div>
                    </td>
                    <td v-if="hayCorteTienda" class="text-center">
                      
                      <button class="btn btn-sm btn-outline-success"
                      @click="agregarAlCorteDeTienda(corte)"  
                      >
                      <i class="fas fa-plus"></i>
                      </button>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-secondary"
                        @click="verDetalleCorte(corte.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-for="corte in currentDetalles.cortes"
                  >
                    <td class="text-center">{{corte.caja.caja}}</td>
                    <td class="text-center">{{corte.numero}}</td>
                    <td class="text-center">{{corte.usuario.nombre}}</td>
                    <td class="text-center">{{corte.fecha_apertura | moment("HH:MM")}}</td>
                    <td v-if="corte.fecha_cierre != null" class="text-center">{{corte.fecha_cierre | moment("HH:MM")}}</td>
                    <td v-else class="text-center"></td>
                    <td colspan="2" class="text-center">Q {{corte.total_detalles}}</td>
                    <td colspan="2" class="text-center">Q {{corte.total_corte}}</td>
                    <td class="text-center">
                      <div
                        :class="{
                          'status-pill green':corte.estado === 'A',
                          'status-pill yellow':corte.estado === 'B',
                          'status-pill blue':corte.estado === 'C',
                          'status-pill dark': corte.estado === 'F',
                          'status-pill red': corte.estado === 'Z',
                        }"
                        :data-title="corte.estado_corte"
                        data-toggle="tooltip"
                      ></div>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-danger"
                      v-if="current.estado == 'A'"
                      @click="quitarDelCorteDeTienda(corte)"
                    >
                      <i class="fas fa-minus"></i>
                      </button>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-secondary"
                        @click="verDetalleCorte(corte.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12 mt-5 table-responsive">
              <center>
                <h5>Resumen de cortes</h5><br>
              </center>
              <table style="font-size: 10px;" class="table table-bordered">
                <thead>
                  <tr >
                    <th colspan="2" class="text-center"></th>
                    <th colspan="7" class="text-center">Datos de Caja</th>
                    <th colspan="2" class="text-center">Notas de Crédito</th>
                    <th colspan="2" class="text-center">Devoluciones</th>
                    <th colspan="2" class="text-center">Totales</th>
                    <th colspan="2" class="text-center">Diferencia</th>
                    <th colspan="3" class="text-center">Ventas</th>
                  </tr>
                  <tr style="border-bottom: 2px solid #000 !important;">
                    <th class="text-center">Caja</th>
                    <th class="text-center">#</th>
                    <th class="text-center">Retiros</th>
                    <th class="text-center">Efectivo</th>
                    <th class="text-center">Tarjetas</th>
                    <th class="text-center">Cheques</th>
                    <th class="text-center">Cert</th>
                    <th class="text-center">Depósitos</th>
                    <th class="text-center">NC Ingresadas</th>
                    <th class="text-center">Aplicadas</th>
                    <!--<th class="text-center">Notas No Aplicadas</th>-->
                    <th class="text-center">Emitidas</th>
                    <th class="text-center">Dev Efectivo</th>
                    <th class="text-center">Dev Efectivo</th>
                    <th class="text-center">Caja</th>
                    <th class="text-center">Sistema</th>
                    <th class="text-center">Faltantes</th>
                    <th class="text-center">Sobrantes</th>
                    <th class="text-center">Crédito</th>
                    <th class="text-center">Neta</th>
                    <th class="text-center">Bruta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="currentDetalles.cortes.length < 1"
                  >
                    <td colspan="20" class="text-center">Aún no hay datos para mostrar...</td>
                  </tr>
                  <tr
                    v-else
                    v-for="corte in currentDetalles.cortes"
                  >
                    <td class="text-center">{{corte.caja.caja}}</td>
                    <td class="text-center">{{corte.numero}}</td>
                    <td class="text-right">Q {{corte.resumen.RETIRO_EFECTIVO}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_EFECTIVO}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_TARJETA_CREDITO}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_CHEQUE}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_CERT}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_DEPOSITO}}</td>
                    <td class="text-right">Q {{corte.resumen.CAJERO_NC}}</td>
                    <td class="text-right">Q {{corte.resumen.NC}}</td>
                    <!--<td class="text-right">Q {{corte.resumen.NC_NA}}</td>-->
                    <td class="text-right">Q {{corte.resumen.NOTA}}</td>
                    <td class="text-right">Q {{corte.resumen.DEVOLUCION_EFECTIVO}}</td>
                    <td class="text-right" v-if="corte.resumen.DEVOLUCION_EFECTIVO > 0">Q -{{corte.resumen.DEVOLUCION_EFECTIVO}}</td>
                    <td class="text-right" v-else>Q {{corte.resumen.DEVOLUCION_EFECTIVO}}</td>
                    <td class="text-right">Q {{corte.resumen.TOTAL_CAJERO}}</td>
                    <td class="text-right">Q {{corte.resumen.TOTAL_SISTEMA}}</td>
                    <td
                      :class="{
                        'text-right': corte.resumen.FALTANTE === 0,
                        'text-right table-danger': corte.resumen.FALTANTE < 0
                      }"
                    >Q {{corte.resumen.FALTANTE}}
                    </td>
                    <td
                    :class="{
                        'text-right': corte.resumen.SOBRANTE === 0,
                        'text-right table-success': corte.resumen.SOBRANTE > 0
                      }"
                    >Q {{corte.resumen.SOBRANTE}}
                    </td>
                    <td class="text-right">Q {{corte.resumen.VENTA_CREDITO}}</td>
                    <td class="text-right">Q {{corte.resumen.VENTA_NETA}}</td>
                    <td class="text-right">Q {{corte.resumen.VENTA}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr
                    v-if="hayCorteTienda && currentDetalles.cortes.length > 0"
                    style="border-top: 4px double red;font-weight: normal !important;"
                  >
                    <th colspan="2" class="text-left">Total</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_RETIROS }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_EFECTIVO }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_TARJETAS }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_CHEQUES }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_CERT }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_DEPOSITOS }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_INGRESADAS }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_APLICADAS }}</th>
                    <!--<th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_NO_APLICADAS }}</th>-->
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_EMITIDAS }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO }}</th>
                    <th class="text-right" v-if="currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO > 0">Q -{{ currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO }}</th>
                    <th class="text-right" v-else>Q {{ currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_TOTAL_CAJERO }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_TOTAL_SISTEMA }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_FALTANTES }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_SOBRANTES }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_VENTAS_CREDITO }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_VENTA_NETA }}</th>
                    <th class="text-right">Q {{ currentDetalles.totales_resumen.TOTAL_CT_VENTA_BRUTA }}</th>
                  </tr>
                </tfoot>
              </table>
              <small>
                <p>
                  <b>Nota:</b>
                </p>
                <p>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  Existen dos columnas de devolución por efectivo, debido a que en la tabla se visualizan datos de caja, incluyendo las notas de crédito generadas por el sistema por lo que se agregó dos veces compensando la suma total con total de caja por cada corte.
                </p>
              </small>
            </div>
            <div class="col-md-12 mt-5 table-responsive">
              <center>
                <h5>Detalles de operaciones por venta del día</h5>
              </center>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      Fecha de Operación
                    </th>
                    <th>
                      Fecha de Creación
                    </th>
                    <th>
                      Banco
                    </th>
                    <th class="">
                      Cuenta
                    </th>
                    <th class="">
                      Doc
                    </th>
                    <th class="">
                      Refer.
                    </th>
                    <th>
                      Cometario
                    </th>
                    <th class="text-center">
                      Tipo
                    </th>
                    <th class="text-center">
                      Forma Pago.
                    </th>
                    <th class="text-center">
                      Terminal ID
                    </th>
                    <th class="text-left">
                      Total
                    </th>
                    <th class="text-center"
                      colspan="2"
                      v-if="hayCorteTienda && current.estado < 'C'"
                    >Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!hayCorteTienda || formasPagoCargado === false || currentDetalles.formas_pago.length === 0 "><td colspan="10" class="text-center">Aún no hay datos para mostrar...</td></tr>
                  <tr v-else v-for="current_d in currentDetalles.formas_pago">
                    <td>
                      {{ current_d.fecha_operacion | moment('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td>
                      {{ current_d.fecha_creacion | moment('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td v-if="current_d.banco">
                      {{ current_d.banco_obj.nombre }}
                    </td>
                    <td v-else></td>
                    <td v-if="current_d.cuenta_bancaria">
                      {{ current_d.cuenta_bancaria_obj.id }}
                    </td>
                    <td v-else></td>
                    <td v-if="current_d.documento">
                      <div class="btn-group">
                        <div class="dropleft">
                          <button class="btn btn-sm btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" :href="current_d.documento" target="_blank">
                              <i class="fas fa-eye"></i> Ver documento
                            </a>
                            <button type="button" v-if="current.estado === 'B'" @click="selectDetalleDocumento(current_d)" class="dropdown-item">
                              <i class="fas fa-edit"></i> Editar documento
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td v-else>
                      <button class="btn btn-sm btn-outline-secondary" @click="selectDetalleDocumento(current_d)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </td>
                    <td>
                      {{ current_d.referencia }}
                    </td>
                    <td>
                      {{ current_d.comentario }}
                      <small v-if="current_d.forma_pago === 'CHEQUE' && current_d.es_prefechado">- Prefechado</small>
                    </td>
                    <td class="text-center">
                      {{ tipoOperacion(current_d.tipo) }}
                    </td>
                    <td class="text-center">
                      {{ current_d.forma_pago }}
                    </td>
                    <td v-if="current_d.terminal">
                      {{ current_d.terminal_obj.terminal_id }}
                    </td>
                    <td v-else></td>
                    <td class="text-left">
                      Q {{ current_d.total }}
                    </td>
                    <td class="text-center" v-if="hayCorteTienda && current.estado < 'C'">
                      <button type="button" 
                        class="btn btn-sm btn-outline-warning"
                        @click="operacionEditModal(current_d)" 
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      
                    </td>
                    <td class="text-center" v-if="hayCorteTienda && current.estado < 'C'">
                      <button class="btn btn-sm btn-outline-danger"
                        @click="quitarDetalleCorteTienda(current_d)">
                        <i class="fas fa-minus"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr
                    style="border-top: 4px double red;font-weight: normal !important;"
                  >
                    <td colspan="10" class="text-right">TOTAL</td>
                    <td>Q {{ totalDetalles }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="col-md-12 mt-5 table-responsive">
              <center>
                <h5>Totalizados por ventas</h5>
              </center>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      Forma de Pago
                    </th>
                    <th class="text-left">
                      Detalles del día
                    </th>
                    <th class="text-left">
                      Ventas del día en sistema
                    </th>
                    <th class="text-left">
                      Ventas del día en caja
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!hayCorteTienda || !currentDetalles.cortes">
                  <tr>
                    <td colspan="5" class="text-center">Aún no hay datos para mostrar...</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td>
                      NOTAS DE CREDITO EMITIDAS
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['NC']">
                      Q {{ detallesTotalizados['NC']*-1 }} *
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td class="text-left">
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_EMITIDAS }}
                    </td>
                    <td class="text-left"></td>
                  </tr>
                  <tr>
                    <td>
                      NOTAS DE CREDITO APLICADAS
                    </td>
                    <td class="text-left"></td>
                    <td class="text-left">
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_APLICADAS }}
                    </td>
                    <td class="text-left"></td>
                  </tr>
                  <tr>
                    <td>
                      DEVOLUCION EN EFECTIVO
                    </td>
                    <td class="text-left"></td>
                    <td class="text-left"></td>
                    <td class="text-left" v-if="currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO > 0">
                      Q -{{  currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO }}
                    </td>
                    <td class="text-left" v-else>
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_DEVOLUCIONES_EFECTIVO }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      NOTAS DE CREDITO INGRESADAS
                    </td>
                    <td class="text-left"></td>
                    <td class="text-left"></td>
                    <td class="text-left">
                      Q {{  currentDetalles.totales_resumen.TOTAL_CT_NOTAS_INGRESADAS }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      CERTIFICADO
                    </td>
                    <td class="text-left"></td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CERT_SISTEMA}}
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CERT}}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-left"></td>
                    <td class="text-left" v-if="currentDetalles.totales_resumen.TOTAL_CT_CERT_SISTEMA>0">
                      Q -{{currentDetalles.totales_resumen.TOTAL_CT_CERT_SISTEMA}}
                    </td>
                    <td class="text-left" v-else>
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CERT_SISTEMA}}
                    </td>
                    <td class="text-left" v-if="currentDetalles.totales_resumen.TOTAL_CT_CERT>0">
                      Q -{{currentDetalles.totales_resumen.TOTAL_CT_CERT}}
                    </td>
                    <td class="text-left" v-else>
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CERT}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      CHEQUE
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['CHEQUE']">
                      Q {{ detallesTotalizados['CHEQUE'] }}
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CHEQUES_SISTEMA}}
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_CHEQUES}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      DEPOSITO
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['DEPOSITO']">
                      Q {{ detallesTotalizados['DEPOSITO'] }}
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_DEPOSITOS_SISTEMA}}
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_DEPOSITOS}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      EFECTIVO
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['EFECTIVO']">
                      Q {{ detallesTotalizados['EFECTIVO'] }} *
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_EFECTIVO_SISTEMA}}
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_EFECTIVO_TOTAL}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      TARJETA DE CREDITO
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['TARJETA_CREDITO']">
                      Q {{ detallesTotalizados['TARJETA_CREDITO'] }}
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_TARJETAS_SISTEMA}}
                    </td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_TARJETAS}}
                    </td>
                  </tr>
                  <tr
                    style="border-top: 4px double red;font-weight: normal !important;"
                  >
                    <td>
                      SUBTOTAL
                    </td>
                    <td class="text-left">
                      Q {{ subtotalDetallesTotalizados }}
                    </td>
                    <td>Q {{ totalSistema }}</td>
                    <td class="text-left">
                      Q {{ subtotalCaja }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      FALTANTES
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['FALTANTES']">
                      Q {{ detallesTotalizados['FALTANTES'] }}
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td></td>
                    <td class="text-left">
                      Q {{currentDetalles.totales_resumen.TOTAL_CT_FALTANTES*-1}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      SOBRANTES
                    </td>
                    <td class="text-left" v-if="detallesTotalizados['SOBRANTES']">
                      Q -{{ detallesTotalizados['SOBRANTES'] }}
                    </td>
                    <td class="text-left" v-else>
                      Q 0
                    </td>
                    <td></td>
                    <td class="text-left">
                      Q -{{currentDetalles.totales_resumen.TOTAL_CT_SOBRANTES}}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr
                    style="border-top: 4px double red;font-weight: normal !important;"
                  >
                    <td class="text-right">TOTAL</td>
                    <td class="text-left">Q {{ totalDetallesTotalizados }}</td>
                    <td class="text-left">Q {{ totalSistema }}</td>
                    <td class="text-left">Q {{ totalCajaTotalizados }}</td>
                  </tr>
                </tfoot>
              </table>
              <small>
                <p>
                  <b>Nota:</b>
                </p>
                <p>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  En la columna detalles del día en forma de pago EFECTIVO si está marcado con asterisco (<b>*</b>), indica incluye el <b>(EFECTIVO + SOBRANTE)</b>, debido a que en venta de caja por la misma forma de pago representa o debería representar lo mismo.
                </p>
                <p>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  El valor de Nota de Crédito Emitida marcada con asterisco (<b>*</b>) en la columna Detalles del día no debe tomarse en cuenta al sumar ya que es simbólico y no representa parte de la venta, únicamente en esa columna.
                </p>
                <p>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  El monto por cheques que fueron agregados como prefechados no apareceran en esta tabla, por ser únicamente representativo por el documento.
                </p>
                <p>
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  Se realiza la resta de certificado debido a que este no es un ingreso del día como tal, sino que es un pago anticipado de otro día.
                </p>
              </small>
            </div>
            <div class="col-md-12 mt-5 table-responsive">
              <center>
                <h5>Resumen Cuadre</h5>
              </center>
              <table class="table table-bordered">
                
                <tbody v-if="!hayCorteTienda || currentDetalles.cortes.length === 0">
                  <tr>
                    <td colspan="12" class="text-center">Aún no hay datos para mostrar...</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-left">
                      Detalles
                    </td>
                    <td class="text-left">
                      Operaciones
                    </td>
                    <td class="text-left">
                      Faltantes
                    </td>
                    <td></td>
                    <td class="text-left">
                      Total Detalles
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                    </td>
                    <td class="text-left">
                      Q {{ current.total_detalle_operaciones}}
                    </td>
                    <td class="text-left">
                      Q {{ current.total_detalle_faltantes}}
                    </td>
                    <td class="text-left">
                    </td>
                    <td class="text-left">
                      Q {{ totalOperacionesFaltantes }}
                    </td>
                    
                  </tr>
                  <tr>
                    <td class="text-left">
                      Venta
                    </td>
                    <td class="text-left">
                      Venta Bruta
                    </td>
                    <td class="text-left">
                      Notas de crédito
                    </td>
                    <td class="text-left">
                      Venta al crédito
                    </td>
                    <td class="text-left">
                      Total Venta
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                    </td>
                    <td class="text-left">
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_VENTA_BRUTA }}
                    </td>
                    <td class="text-left" v-if="currentDetalles.totales_resumen.TOTAL_CT_NOTAS_EMITIDAS<0">
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_NOTAS_EMITIDAS }}
                    </td>
                    <td class="text-left" v-else>Q 0.00</td>
                    <td class="text-left" v-if="currentDetalles.totales_resumen.TOTAL_CT_VENTAS_CREDITO>0">
                      Q {{ currentDetalles.totales_resumen.TOTAL_CT_VENTAS_CREDITO*-1 }}
                    </td>
                    <td class="text-left" v-else>Q 0.00</td>
                    <td class="text-left">
                      Q {{ totalVenta }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">Diferencia (Total Detalles - Total Venta)</td>
                    <td :class="{
                      'text-left bg-success text-white':resultadoCuadre > 0,
                      'text-left bg-danger text-white': resultadoCuadre < 0,
                      'text-left': resultadoCuadre === 0,
                      }"
                    >
                      Q {{ resultadoCuadre }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="col-md-12 mt-5" v-if="hayCorteTienda">
              <center><h5>Documentos por totalizados</h5></center>
              <div v-for="fp in formasPago">
                <h6 class="mb-3">
                  {{ fp }}
                  <button class="btn btn-sm btn-outline-success" @click="selectFormaPago(fp)">
                    <i class="fas fa-plus"></i>
                  </button>
                </h6>
                <CarruselArchivosComponent 
                  :items="archivostTotalizados(fp)"
                ></CarruselArchivosComponent>
              </div>
            </div>
            <NuevaOperacionComponent
              v-if="hayCorteTienda && cargado"
              :current=current
              :tienda=currentDetalles.tienda
              :currentFullDate=currentFullDate
              :total-ventas=totalVenta
              :total-detalles=totalOperacionesFaltantes
              @refreshCorte="refreshCurrent"
            >
            </NuevaOperacionComponent>
            <EditarOperacionComponent
              v-if="hayCorteTienda && cargado"
              :corte_tienda=current
              :tienda=currentDetalles.tienda
              :currentFullDate=currentFullDate
              :total-ventas=totalVenta
              :total-detalles=totalOperacionesFaltantes
              ref="editarOperacionModal"
              @refreshCorte="refreshCurrent"
            >
            </EditarOperacionComponent>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ESTADOS -->
    <div class="modal fade" id="estadosCortes" tabindex="-1" aria-labelledby="estadosCortesLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="estadosCortesLabel">Estados para días en el calendario</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img style="max-width: 100%;margin-bottom: 0;" src="/img/estados_cortes/estados_cortes.png" alt="">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL ESTADOS -->
    <!-- Modal Seleccionar Fecha -->
    <div class="modal fade" id="seleccionarDia" tabindex="-1" aria-labelledby="seleccionarDiaLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="seleccionarDiaLabel">Seleccione la fecha que desea</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class="form-control" type="date" v-model="fechaSeleccionada">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="seleccionarFecha()"
              class="btn btn-primary"
            >
              Buscar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin de Modal Seleccionar Fecha -->
     <!-- Modal Seleccionar Actualizar Documento Detalle -->
    <div class="modal fade" id="subirDocumentoDetalleModal" tabindex="-1" aria-labelledby="subirDocumentoDetalleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="subirDocumentoDetalleModalLabel">Seleccione el documento a subir</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class="form-control" type="file" id="documentoUpdate" ref="documentoUpdate" name="documentoUpdate" accept="application/pdf">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="updateDocumentoDetalle()"
              class="btn btn-primary"
            >
              Subir
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin de Modal Seleccionar Actualizar Documento Detalle -->
     <!-- Modal Subir Documento Forma Pago -->
    <div class="modal fade" id="formaPagoUploadDocumentModal" tabindex="-1" aria-labelledby="formaPagoUploadDocumentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="formaPagoUploadDocumentModalLabel" v-if="formaPagoSeleccionado">Seleccione el documento a subir para {{ formaPagoSeleccionado }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class="form-control" type="file" id="formaPagoDocumento" ref="formaPagoDocumento" name="formaPagoDocumento" accept="application/pdf">
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="saveDocumentoFormaPago()"
              class="btn btn-primary"
            >
              Subir
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin de Modal Subir Documento Forma Pago -->
    <!-- Modal Logs -->
    <LogsTableModalComponent
      v-if="hayCorteTienda"
      modulo="cxc"  
      path="cortes-tienda-logs"
      :params="{corte_tienda:current.id}"
      ref="logs"
    ></LogsTableModalComponent>
    <!-- Fin de Modal Logs -->

    <!-- Modal Nueva Anotacion -->
    <AnotacionComponent 
      v-if="hayCorteTienda"
      :is-visible="showAnotacionModal"
      @close="showAnotacionModal = false"
      :corte-tienda="current"
      :total-venta="totalVenta"
      :total-detalles="totalOperacionesFaltantes"
    ></AnotacionComponent>
    <!-- Fin Anotacion -->
    
    <!-- Lista Anotaciones -->
    <ListaAnotacionesComponent
      v-if="hayCorteTienda"
      :corte_tienda_id="current.id"
      ref="listaAnotaciones"
    ></ListaAnotacionesComponent>
    <!-- Fin Lista Anotaciones -->
    
    <!-- Login -->
    <LoginVerify @login="handleLogin"></LoginVerify>
    <!-- Fin de Login -->
  </div>
</template>

<script>

import DynamicService from "@/services/commons/DynamicService";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";
import CorteTiendaService from "@/services/cxc/CorteTiendaService";
import Notifications from "@/notifications/notifications";
import NoPermitidoComponent from "@/components/commons/NoPermitidoComponent";
import LoginVerify from "@/components/commons/LoginVerify"; // Se usa loginVerifyModal para llamar el modal devuelve el usuario y contraseña
import LogsTableModalComponent from "@/components/commons/LogsTableModalComponent";
import NuevaOperacionComponent from "@/components/cxc/corte_tienda/NuevaOperacionComponent";
import EditarOperacionComponent from "@/components/cxc/corte_tienda/EditarOperacionComponent";
import CarruselArchivosComponent from "@/components/commons/CarruselArchivosComponent";
import AnotacionComponent from "@/components/cxc/corte_tienda/AnotacionComponent";
import ListaAnotacionesComponent from "@/components/cxc/corte_tienda/ListaAnotacionesComponent";

export default {
  components: {
    LoaderComponent,NoPermitidoComponent,LoginVerify,
    LogsTableModalComponent,NuevaOperacionComponent,
    CarruselArchivosComponent,AnotacionComponent,
    ListaAnotacionesComponent,EditarOperacionComponent
  },
  props: {
  },
  data() {
    const today = new Date();
    return {
      operacionSelected:null,
      showAnotacionModal:false,
      formasPago:["EFECTIVO","NC","TARJETA_CREDITO","CHEQUE","DEPOSITO"],
      cajas:[],
      terminales:[],
      currentDay: "",
      action:null,
      usuario:{
        username: null,
        password:null,
      },
      estadosCortesTiendaCargados:false,
      estadosCortesTienda:[],
      permisos:{
        CONTA:6,
        ADMIN:15,
        JEFES:3,
        SUBJEFES:4,
      },
      operacion: {
        tipo: "O",
        fecha:"",
        hora:"",
        fecha_operacion: "",
        referencia: "",
        comentario: "",
        banco: null,
        cuenta_bancaria: null,
        forma_pago: "EFECTIVO",
        total: 0,
        documento: null,
        terminal:null,
        terminal_obj:null,
        es_prefechado:false,
      },
      formaPagoSeleccionado:null,
      detalleSeleccionado:null,
      fechaSeleccionada:"",
      estadosCargados:false,
      datosCargados:false,
      formasPagoCargado:false,
      hoy:today,
      minDate:null,
      maxDate:null,
      current:null,
      currentDetalles:{
        id:null,
        tiendas: null,
        tienda:{
          codigo:null,
          nombre:""
        },
        formas_pago_credito:[],
        cortes:null,
        cortes_tienda:null,
        estados_cortes:null,
        totales_resumen:null,
        formas_pago:null,
        detalles_totalizados:null,
        documentos_fp:null,
      },
      bancos:null,
      cuentas_bancarias:null,
      showModal: false,
      selectedDate: '',
      currentMonth: today.getMonth(),
      currentYear: today.getFullYear(),
      dayNames: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
    };
  },
  watch:{
    referencia_operacion(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
    banco_operacion(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
    terminal_id(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
  },
  computed: {
    subtotalDetallesTotalizados(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.current.total_detalle_operaciones+self.current.total_detalle_sobrantes);
      }
      return parseFloat(total.toFixed(2));
    },
    totalDetallesTotalizados(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat((self.subtotalDetallesTotalizados+self.current.total_detalle_faltantes) - self.current.total_detalle_sobrantes);
      }
      return parseFloat(total.toFixed(2));
    },
    subtotalCaja(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_TOTAL_CAJERO);
        total -= parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_CERT);
      }
      return parseFloat(total.toFixed(2));
    },
    totalCajaTotalizados(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat((self.subtotalCaja-self.currentDetalles.totales_resumen.TOTAL_CT_SOBRANTES)+(self.currentDetalles.totales_resumen.TOTAL_CT_FALTANTES*-1))
      }
      return parseFloat(total.toFixed(2));
    },
    listoParaFinalizar(){
      let self = this;
      return self.hayCorteTienda && self.current.estado === 'B' && (self.resultadoCuadre >= 0) ? true : false;
    },
    resultadoSobranteFaltante(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_SOBRANTES);
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_FALTANTES);
      }
      return parseFloat(total.toFixed(2));
    },
    resultadoCuadre(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.totalOperacionesFaltantes);
        total -= parseFloat(self.totalVenta);
      }
      return parseFloat(total.toFixed(2));
    },
    totalVenta(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_VENTA_BRUTA);
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_NOTAS_EMITIDAS);
        total -= parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_VENTAS_CREDITO);
      }
      return parseFloat(total.toFixed(2));
    },
    totalCajero(){
      let self = this;
      let total = 0;
      if (self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_TOTAL_CAJERO);
      }
      return parseFloat(total.toFixed(2));
    },
    totalSistema(){
      let self = this;
      let total = 0;
      if ( self.hayCorteTienda && self.currentDetalles.cortes){
        total += parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_TOTAL_SISTEMA);
        total -= parseFloat(self.currentDetalles.totales_resumen.TOTAL_CT_CERT_SISTEMA);
      }
      return parseFloat(total.toFixed(2));
    },
    numero_afiliacion(){
      let terminal = ""
      if (this.operacion.terminal){
        terminal = this.terminales.find(terminal => terminal.id === this.operacion.terminal)
        return terminal.afiliacion;
      }
      return null;
    },
    terminal_id(){
      return this.operacion.terminal
    },
    banco_operacion(){
      return this.operacion.banco;
    },
    referencia_operacion(){
      return this.operacion.referencia;
    },
    currentFullDate(){
      return `${this.currentDay} de ${this.currentMonthName} del ${this.currentYear}`
    },
    currentMonthName() {
      return new Date(this.currentYear, this.currentMonth).toLocaleString('es-ES', { month: 'long' });
    },
    daysInMonth() {
      const days = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const firstDayIndex = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const emptyDays = Array(firstDayIndex).fill(null);
      return [...emptyDays, ...Array.from({ length: days }, (_, i) => i + 1)];
    },
    minDateObj() {
      return this.minDate ? new Date(this.minDate) : null;
    },
    maxDateObj() {
      return this.maxDate ? new Date(this.maxDate) : null;
    },
    cargado(){
      return this.datosCargados && this.estadosCargados && this.estadosCortesTiendaCargados;
    },
    hayCortes(){
      return this.currentDetalles.cortes_disponibles.length > 0 || this.currentDetalles.cortes.length > 0;
    },
    hayCorteTienda(){
      return this.current != null;
    },
    usuarioPermitido(){
      let self = this;
      let permitido = false;
      const gruposJSON = localStorage.getItem("grupos");
      const grupos = JSON.parse(gruposJSON);
      permitido = grupos.some(grupo => grupo.id === self.permisos.CONTA || grupo.id === self.permisos.ADMIN || grupo.id === self.permisos.JEFES || grupo.id === self.permisos.SUBJEFES)
      return permitido;
    },
    totalOperacionesFaltantes(){
      let self = this;
      let total = 0;
      if(self.hayCorteTienda){
        total = self.current.total_operacion_faltantes
      }
      return parseFloat(total.toFixed(2));
    },
    totalDetalles(){
      let self = this;
      let total = 0;
      if(self.hayCorteTienda){
        total = self.current.total_detalle
      }
      return parseFloat(total.toFixed(2));
    },
    detallesTotalizados(){
      let obj = {}
      
      this.currentDetalles.detalles_totalizados.forEach(detalle => {
        if(detalle.forma_pago === 'EFECTIVO'){
          obj[detalle.forma_pago] = parseFloat((detalle.total_resumen - this.current.total_detalle_faltantes).toFixed(2));
        }else{
          obj[detalle.forma_pago] = parseFloat(detalle.total_resumen.toFixed(2));
        }
      })
      obj['FALTANTES']=parseFloat(this.current.total_detalle_faltantes)
      obj['SOBRANTES']=parseFloat(this.current.total_detalle_sobrantes)
      return obj;
    },
  },
  mounted() {
    let self = this;
    if(!self.usuarioPermitido){
      self.$toast.error("No tienes permisos para acceder o visualizar este recurso.","Error",{position: 'topRight'});
    }
    self.handleRouteId();
    DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
        quitar_paginacion: true
      })
      .then((response) => {
        if (response.data.length > 0) {
          let tiendas = []
          response.data.forEach(asignacion => {
            tiendas.push(asignacion.tienda);
          });
          self.currentDetalles.tiendas = tiendas;
          self.currentDetalles.tienda.codigo = response.data[0].tienda.codigo;
          self.currentDetalles.tienda.nombre = response.data[0].tienda.nombre;
          self.currentDetalles.id = response.data[0].tienda.id;
          self.refreshCurrent();
        } else {
          self.$toast.warning("Debes estar asignado a una tienda para visualizar los cortes, ¡solicite que se le asigne la tienda en donde se encuentra!","Aviso",{position: 'topRight'});
        }
      })
  },
  methods: {
    verAnotaciones(){
      $("#modalAnotaciones").modal("show");
      this.$refs.listaAnotaciones.refreshAnotaciones();
    },
    operacionEditModal(operacion){
      //this.operacionSelected = null;
      // Llama al método showModal del componente hijo usando su ref
      this.$refs.editarOperacionModal.showModal(operacion);
    },
    handleOperacionUpdated() {
      this.refreshCurrent(); 
    },
    nuevaAnotacion(){
      this.$refs.anotacionModalRef.showModal();
    },
    archivostTotalizados(formaPago){
      let archivos = [];
      let i = 0;
      if(this.currentDetalles.documentos_fp){
        this.currentDetalles.documentos_fp.forEach(doc => {
          if (doc.forma_pago === formaPago){
            i++;
            let archivo = {
              id: doc.id,
              nombre: `${formaPago}_${i}`,
              url: doc.ruta,
            };
            archivos.push(archivo);
          }
        })
      }
      return archivos;
    },
    tipoOperacion(tipo){
      if(tipo === "O"){
        return "Operación";
      }else if(tipo === "F"){
        return "Faltante";
      }else if(tipo === "S"){
        return "Sobrante";
      }
    },
    esFechaValida(fechaString) {
      return moment(fechaString, "DD/MM/YYYY", true).isValid();
  },
    handleRouteId() {
      if (!this.$route.params.id) {
        const month = String(this.currentMonth + 1).padStart(2, '0');
        const day = String(this.hoy.getDate()).padStart(2, '0');

        let date = `${this.currentYear}-${month}-${day}`;
        this.$router.push({
          name: 'cxc-corte-tienda-date',
          params: { id: date },
        });
        window.location.reload();
      } else {
        let date = this.$route.params.id;
        let datef = moment(date).format('DD/MM/YYYY');
        if(!this.esFechaValida(datef)){
          this.$toast.error("La fecha indicada no existe, por favor seleccione una fecha existente.","Error",{position: 'topRight'});
          return;
        }
        let partesFecha = datef.split("/");
        let day = parseInt(partesFecha[0]);
        let month = parseInt(partesFecha[1]) - 1; // Los meses en JavaScript son 0-indexados (0 = enero)
        let year = parseInt(partesFecha[2]);

        this.currentMonth = month;
        this.currentYear = year;
        this.currentDay = day;
        let spam = "Dejo esta variable como spam jajaja, es demasiado código que si toca modificarlo lo siento"
        this.selectedDate = `${this.currentDay}/${this.currentMonth+1}/${this.currentYear}`;
      }
    },
    refreshFormasPagoDocumentos(){
      let self = this;
      DynamicService.fetch(
        "cxc",
        "corte-tienda-forma-pago-docs",
        {
          corte_tienda: self.current.id,
        }
      )
       .then((response) => {
          self.currentDetalles.documentos_fp = response.data.results;
        })
       .catch((errors) => {
          if (errors.response) {
            self.$toast.warning(JSON.stringify(errors.response.data),"Aviso",{position: 'topRight'});
          }
        });
    },
    selectDetalleDocumento(detalle){
      let self = this;
      self.detalleSeleccionado = detalle;
      $("#subirDocumentoDetalleModal").modal("show");
    },
    selectAction(action){
      let self = this;
      self.action = null;
      self.action = action;
    },
    handleLogin(user) {
      this.user = user;
      if(this.action === 'apertura'){
        this.aperturar_tienda();
      }else if(this.action === 'finalizar'){
        this.finalizar();
      }else if(this.action === 'auditar'){
        this.auditar();
      }
    },
    aperturar_tienda(){
      let self = this;
      let params = {
        tienda: self.currentDetalles.tienda.codigo,
        usuario: self.user.username,
        clave: self.user.password,
        fecha: self.selectedDate,
      }
      DynamicService.postActionList(
        "cxc",
        "corte-caja-tienda",
        "aperturar_tienda",
        params
      )
       .then((response) => {
          Notifications.alert.success(
            "Corte de Tienda",
            response.data.detail
          );
          self.user.username = null;
          self.user.password = null;
          self.refreshCurrent();
        })
       .catch((errors) => {
          if ('data' in errors.response) {
            Notifications.alert.error(
              "Corte de Tienda",
              JSON.stringify(errors.response.data)
            );
          }
        });
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas realizar el cierre de la tienda?",
        "Si Cerrar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "cerrar"
          )
          .then((response) => {
            Notifications.alert.success(
              "Corte de Tienda",
              "Corte de Tienda Realizado con Éxito"
            );
            self.refreshCurrent();
          }) 
          .catch((errors) => {
            console.error(errors)
            if ('data' in errors.response) {
              Notifications.alert.error(
                "Corte de Tienda",
                JSON.stringify(errors.response.data)
              );
            }
          });
        }
      );
    },
    finalizar() {
      let self = this;
      // Se manda los totales para no hacer un recalculo en el backend ahorrando un poco de tiempo en la petición, no es lo más aconsejable
      let params = {
        usuario: self.user.username,
        clave: self.user.password,
        total_ventas:self.totalVenta,
        total_detalles:self.totalOperacionesFaltantes
      }
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas finalizar el corte de la tienda?",
        "Si abrir",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "finalizar",
            params
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Tienda",
                "Corte de Tienda Finalizado"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Corte de Tienda",
                  JSON.stringify(errors.response.data)
                );
              }
            });
        }
      );
    },
    auditar(){
      let self = this;
      let params = {
        usuario: self.user.username,
        clave: self.user.password,
      }
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas auditar el corte de la tienda?",
        "Si",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "auditar",
            params
          )
          .then((response) => {
            Notifications.alert.success(
              "Corte de Tienda",
              JSON.stringify(response.data.detail)
            );
            self.refreshCurrent();
          })
          .catch((errors) => {
            if (errors.response) {
              console.error(JSON.stringify(errors.response.data));
              self.$toast.error(JSON.stringify(errors.response.data),"Error",{position: 'topRight'});
            }
          });
        })
    },
    tiendaSeleccionada(){
      let tienda = this.currentDetalles.tiendas.find((tienda) => tienda.codigo === this.currentDetalles.tienda.codigo);
      this.currentDetalles.tienda.nombre = tienda.nombre;
    },
    seleccionarFecha(){
      let self = this;
      if(self.fechaSeleccionada === "") {self.$toast.warning("No se ha seleccionado ninguna fecha","Aviso",{position: 'topRight'});return;}
      self.currentMonth = moment(self.fechaSeleccionada).month();
      self.currentYear = moment(self.fechaSeleccionada).year();
      self.selectDay(moment(self.fechaSeleccionada).date());
      $("#seleccionarDia").modal("hide");
    },
    selectDate(){
      $("#seleccionarDia").modal("show");
    },
    verDetalleCorte(id){
      let routeUrl = this.$router.resolve({
        name: "cxc-corte-caja-editar",
        params: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    refreshCortesTienda(){
      let self = this;
      self.estadosCortesTiendaCargados=false;
      let params = {
        tienda: self.currentDetalles.tienda.codigo,
      }
      DynamicService.postActionList("cxc", "corte-caja-tienda","obtener_estados_cortes_tienda", params)
       .then((response) => {
          self.estadosCortesTienda = response.data;
          self.estadosCortesTiendaCargados = true;
        })
    },
    
    getEstadoCortesTienda(day){
      let self = this;
      if(!day || !self.hayCorteTienda){
        return;
      }
      let dia = String(day).padStart(2,"0");
      let mes = String(self.currentMonth + 1).padStart(2,"0");
      let fecha = `${self.currentYear}-${mes}-${dia}`;
      let corte = self.estadosCortesTienda.find(cort => cort.fecha === fecha)
      if(!corte){
        return;
      }
      if(corte.estado === 'A'){
        return 'border:4px solid #71c21a';
      } else if(corte.estado === 'B'){
        return 'border:4px solid #0400f0';
      } else if(corte.estado === 'C'){
        return 'border:4px solid #343a40';
      } else if(corte.estado === 'D'){
        return 'border:4px solid #c21a1a';
      }
    },

    estadoCortes(day){
      if(day == null){return;}
      let self = this;
      let dia = String(day).padStart(2,"0");
      let mes = String(self.currentMonth + 1).padStart(2,"0");
      let fecha = `${self.currentYear}-${mes}-${dia}`;
      let resultado = null;
      let corte = self.currentDetalles.estados_cortes.find((corte) => moment(corte.fecha).format("YYYY-MM-DD") === fecha);
      if(self.currentDetalles.estados_cortes.length > 0 && corte){
        if(corte.aperturados === corte.cantidad){
          resultado = 'A';
        }else if (corte.cerrados === corte.cantidad){
          resultado = 'C';
        }else if (corte.aperturados >= 0 || corte.pendientes >= 0 || corte.cerrados >= 0 || corte.pendientes === corte.cantidad){
          resultado = 'B';
        }
      }
      return resultado;
    },
    changeMonth(direction) {
      this.currentMonth += direction;
      if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      }
    },
    isToday(day) {
      const today = new Date();
      return (
        day === today.getDate() &&
        this.currentMonth === today.getMonth() &&
        this.currentYear === today.getFullYear()
      );
    },
    isDisabled(day) {
      if (!day) return true;
      const date = new Date(this.currentYear, this.currentMonth, day);
      if (this.minDateObj && date < this.minDateObj) return true;
      if (this.maxDateObj && date > this.maxDateObj) return true;
      return false;
    },
    selectDay(day) {
      const self = this;
      self.selectedDate = `${day}/${self.currentMonth + 1}/${self.currentYear}`;
      self.currentDay = day;
      const mes = String(self.currentMonth + 1).padStart(2, '0');
      const dia = String(day).padStart(2, '0');
      let date = `${self.currentYear}-${mes}-${dia}`;
      this.$router.push({
        name: 'cxc-corte-tienda-date',
        params: { id: date },
      });
        //window.location.reload();
      self.refreshCurrent();
    },
    isSelectedDay(day){
      return this.selectedDate === `${day}/${this.currentMonth + 1}/${this.currentYear}`;
    },
    refreshCurrentEstadosCorte(){
      let self = this;
      self.estadosCargados = false;
      CorteTiendaService.postActionList("obtener_estados_de_cortes", {
        tienda: self.currentDetalles.tienda.codigo,
      })
      .then((response) => {
        self.minDate = response.data.fecha_min;
        self.maxDate = self.hoy;
        self.currentDetalles.estados_cortes = response.data.cortes;
        self.estadosCargados = true;
      })
    },
    refreshCurrent(){
      let self = this;
      self.tiendaSeleccionada();
      self.datosCargados = false;
      CorteTiendaService.postActionList("obtener_cortes", {
        fecha: self.selectedDate,
        tienda: self.currentDetalles.tienda.codigo,
      })
      .then((response) => {
        if(response.status == 200) {
          self.current = response.data.corte_tienda;
          if(self.hayCorteTienda){
            self.currentDetalles.detalles_totalizados = self.current.totalizados_detalle;
            self.refreshDetallesCortes();
            self.refreshFormasPagoDocumentos();
          }
          self.currentDetalles.cortes = response.data.cortes;
          self.currentDetalles.cortes_disponibles = response.data.cortes_disponibles;
          self.currentDetalles.totales_resumen = response.data.totales_resumen;
          self.currentDetalles.num_cortes = response.data.cortes.length;
          self.datosCargados = true;
          self.refreshCortesTienda();
          self.refreshCurrentEstadosCorte();
        }
      })
    },
    refreshDetallesCortes(){
      let self = this;
      self.formasPagoCargado=false;
      let params = {
        corte_tienda: self.current.id,
        quitar_paginacion: true,
      };
      DynamicService.fetch("cxc","cortes-tienda-detalles",params)
      .then((response) =>{
        self.currentDetalles.formas_pago = response.data;
        self.formasPagoCargado=true;
      });
    },
    agregarAlCorteDeTienda(corte) {
      let self = this;
      if(!self.hayCorteTienda){self.$toast.warning("No hay ninguna apertura creada en esta fecha.","Aviso",{position: 'topRight'});return;}
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        self.current.id,
        'agregar_corte',
        {
          id: corte.id
        }
      )
      .then((response) => {
        self.$toast.success(JSON.stringify(response.data.detail), "Hecho", { position: 'topRight' });
        self.refreshCurrent();
      })
      .catch((error) => {
        if(error.response){
          self.$toast.error(JSON.stringify(error.response.data), "Error", { position: 'topRight' });
        }
      });
    },
    quitarDelCorteDeTienda(corte){
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        self.current.id,
        'quitar_corte',
        {
          id: corte.id
        }
      ).then((response) => {
        self.$toast.success(JSON.stringify(response.data.detail), "Hecho", { position: 'topRight' });
        self.refreshCurrent();
      })
      .catch((error) => {
        if(error.response){
          self.$toast.error(JSON.stringify(error.response.data), "Error", { position: 'topRight' });
        }
      });
    },
    selectFormaPago(forma_pago){
      let self = this;
      self.formaPagoSeleccionado = forma_pago;
      $("#formaPagoUploadDocumentModal").modal("show");
    },
    saveDocumentoFormaPago(){
      let self = this;
      const formData = new FormData();
      formData.append('documento', self.$refs.formaPagoDocumento.files[0]);
      formData.append('corte_tienda', self.current.id);
      formData.append('forma_pago', self.formaPagoSeleccionado);
      DynamicService.save(
        "cxc",
        "corte-tienda-forma-pago-docs",
        formData
      ).then((response) => {
        if(response.status === 200 || response.status === 201){
          $("#formaPagoUploadDocumentModal").modal("hide");
          this.$refs.formaPagoDocumento.value = null;
          this.formaPagoSeleccionado = null;
          this.$toast.success("Documento agregado con éxito", "Hecho", { position: 'topRight' });
          this.refreshCurrent();
        }
      })
      .catch((errors) => {
        if(errors.response){
          console.error(JSON.stringify(errors.response.data));
          this.$toast.error(JSON.stringify(errors.response.data), "Error", { position: 'topRight' });
        }
      });
    },
    updateDocumentoDetalle(detalle_id){
      let self = this;
      const formData = new FormData();
      if(!self.$refs.documentoUpdate.files[0]){
        self.$toast.error("No hay un documento seleccionado", "Error", { position: 'topRight' });
        return;
      }
      formData.append('documento', self.$refs.documentoUpdate.files[0]);
      DynamicService.postAction(
        "cxc",
        "cortes-tienda-detalles",
        self.detalleSeleccionado.id,
        'actualizar_documento',
        formData
      ).then((response) => {
        self.$refs.documentoUpdate.value = null;
        self.detalleSeleccionado = null;
        //self.limpiarOperacion();
        $("#subirDocumentoDetalleModal").modal("hide");
        self.$toast.success("Documento agregado con éxito", "Hecho", { position: 'topRight' });
        self.refreshCurrent();
      })
      .catch((errors) => {
        if (errors.response) {
          console.error(errors.response.data);
          Notifications.alert.error(
            "Agregar documento",
            JSON.stringify(errors.response.data)
          );
        }
      });
    },
    quitarDetalleCorteTienda(detalle){
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        self.current.id,
        'quitar_detalle_corte',
        {
          id: detalle.id,
          total_ventas:self.totalVenta,
          total_detalles:self.totalOperacionesFaltantes
        }
      ).then((response) => {
        self.$toast.success(JSON.stringify(response.data.detail), "Hecho", { position: 'topRight' });
        self.refreshCurrent();
      })
      .catch((error) => {
        if(error.response){
          self.$toast.error(JSON.stringify(error.response.data), "Error", { position: 'topRight' });
        }
      });
    },
    verLogs(){
      this.$refs.logs.refreshLogs();
      $("#logModal").modal("show");
    }
  },
};
</script>

<style scoped>
.calendar {
  border:none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #ffffff, #ffffff);
  color: #000000;
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 600px;
  padding: 20px;
  background: rgba(69, 218, 101, 0.2);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(15, 65, 19, 0.1);
}
.calendar-header button {
  background: #385f32;
  color: #d7e1ec;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  font-size: 1.2em;
  transition: background 0.3s;
}
.calendar-header button:hover {
  background: #519e42;
}
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  width: 90%;
  max-width: 600px;
  padding: 20px;
}
.day-name {
  font-weight: bold;
  text-align: center;
  color: #000000;
  text-transform: uppercase;
}
.day {
  text-align: center;
  padding: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(0, 0, 0,0.2);
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #2a7cda;
  transition: background 0.3s, transform 0.2s;
}
.day:hover {
  background: rgba(255, 255, 255, 0.5);
  transform: scale(1.1);
}
.day.is-today {
  background: #e07228;
  color: #fff;
  font-weight: bold;
}
.day.aperturado {
  background: #5bbb36;
  color: #fff;
  font-weight: bold;
}
.day.pendiente {
  background: #d6b031;
  color: #fff;
  font-weight: bold;
}
.day.cerrado {
  background: #1b6c9b;
  color: #fff;
  font-weight: bold;
}
.day.aperturado-select {
  background: #5bbb36;
  border: 3px solid #e07228 !important;
  color: #fff;
  font-weight: bold;
}
.day.pendiente-select {
  background: #d6b031;
  border: 3px solid #e07228 !important;
  color: #fff;
  font-weight: bold;
}
.day.cerrado-select {
  background: #1b6c9b;
  border: 3px solid #e07228 !important;
  color: #fff;
  font-weight: bold;
}
.day.disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
@media (max-width: 860px) {
  .calendar-header {
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }
  
  .calendar-header h3 {
    font-size: 1.2em;
  }

  .calendar-header button {
    font-size: 1em;
    padding: 8px;
    width: 100%; /* Para que los botones se ajusten en pantallas pequeñas */
  }

  .calendar-grid {
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    padding: 10px;
  }

  .day {
    padding: 8px; /* Reduce el tamaño de los días */
    font-size: 0.8em;
  }

  .day-name {
    font-size: 0.9em;
  }

  
}

@media (max-width: 480px) {
  .calendar-header button {
    padding: 6px;
  }

  .calendar-grid {
    grid-template-columns: repeat(7, 1fr); /* Muestra 7 columnas para pantallas ultra pequeñas */
    gap: 3px;
  }

  .day {
    padding: 8px;
    font-size: 0.8em;
  }

  .day-name {
    font-size: 0.9em;
  }
}
@keyframes parpadear {
    0% {
      /* Estado inicial de la animación (color de fondo claro, texto oscuro) */
      background-color: #ffdda1; /* Naranja muy claro */
      color: #a0522d;            /* Marrón oscuro para el texto */
    }
    100% {
      /* Estado final de la animación (color de fondo intenso, texto blanco) */
      background-color: #ff9800; /* Naranja vibrante */
      color: #ffffff;            /* Blanco para el texto */
    }
  } 
  .badge-parpadeo {
    /* Define la animación: nombre, duración, repetición y dirección */
    animation: parpadear 1s infinite alternate; 
  }
</style>